import {pageInfo, details, agree, refuse, useDetail, batchDownloadAnnex, uploadUrl, updateLandcert} from '../api';
const landcertInfo = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    collectionObj: null,
    detailsObj: null,
    uploadUrl,
    agreeObj: null,
    refuseObj: null,
    useDetailsObj: null,
    downloadObjObj: null,
    updateLandcertObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    DEAILS(state, data) {
      state.detailsObj = data;
    },
    AGREE(state, data) {
      state.agreeObj = data;
    },
    REFUSE(state, data) {
      state.refuseObj = data;
    },
    USE_DETAIL(state, data) {
      state.useDetailsObj = data;
    },
    DOWNLOAD(state,data){
      state.downloadObj = data;
    },
    UPDATE_LANDCERT(state, data) {
      state.updateLandcertObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async details({commit}, obj) {
      let resp = await details(obj);
      commit('DEAILS', resp);
    },
    async agree({commit}, obj) {
      let resp = await agree(obj);
      commit('AGREE', resp);
    },
    async refuse({commit}, obj) {
      let resp = await refuse(obj);
      commit('REFUSE', resp);
    },
    async updateLandcert({commit}, obj) {
      let resp = await updateLandcert(obj);
      commit('UPDATE_LANDCERT', resp);
    },
    async useDetail({commit}, obj) {
      let resp = await useDetail(obj);
      commit('USE_DETAIL', resp);
    },
    async batchDownloadAnnex({commit}, obj){
      let resp = await batchDownloadAnnex(obj);
      commit('DOWNLOAD', resp);
    }
  }
}
export default landcertInfo



// WEBPACK FOOTER //
// ./src/page/bd/run/landcertInfo/store/landcertInfo.store.js